'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createEagerFactory = require('recompose/createEagerFactory');

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

var _withHandlers = require('recompose/withHandlers');

var _withHandlers2 = _interopRequireDefault(_withHandlers);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getExposeKeys(arg, props) {
  if (typeof arg === 'function') return Object.keys(arg(props));
  return Object.keys(arg);
}

var exposeHandlers = function exposeHandlers(arg) {
  return function (BaseComponent) {
    var WrappedComp = (0, _withHandlers2.default)(arg)(BaseComponent);
    var factory = (0, _createEagerFactory2.default)(WrappedComp);

    var Expose = function (_React$Component) {
      _inherits(Expose, _React$Component);

      function Expose(props, context) {
        _classCallCheck(this, Expose);

        var _this = _possibleConstructorReturn(this, (Expose.__proto__ || Object.getPrototypeOf(Expose)).call(this, props, context));

        var _selectScope = (0, _utils.selectScope)(context),
            addToExposing = _selectScope.addToExposing;

        var exposeKeys = getExposeKeys(arg, props);
        exposeKeys.map(addToExposing);
        return _this;
      }

      _createClass(Expose, [{
        key: 'render',
        value: function render() {
          return factory(this.props);
        }
      }]);

      return Expose;
    }(_react2.default.Component);

    Expose.contextTypes = _utils.scopeContextTypes;

    return Expose;
  };
};

exports.default = exposeHandlers;


//////////////////
// WEBPACK FOOTER
// ./~/recompose-scope/exposeHandlers.js
// module id = 1056
// module chunks = 0